export const NAV_ITEMS = [
  { id: 'highlights', label: 'Highlights' },
  { id: 'work-impact', label: 'Work & Impact' },
  { id: 'growth-recognition', label: 'Growth & Recognition' },
  { id: 'innovation', label: 'Innovation' },
  { id: 'culture-community', label: 'Culture & Community' },
  { id: 'people', label: 'People' },
  { id: 'future-focus', label: 'Digital 2026' },
];

export const HIGHLIGHT_CARDS = [
  {
    icon: `${process.env.PUBLIC_URL}/teams.svg`,
    value: '591000+',
    title: 'Total Billed Hours',
    category: 'Billable hours',
  },
  {
    icon: `${process.env.PUBLIC_URL}/engagements.svg`,
    value: '45+',
    title: 'New Engagements',
    category: 'Work & Impact',
  },
  {
    icon: `${process.env.PUBLIC_URL}/revenue.svg`,
    value: '55M+',
    title: 'Revenue',
    category: 'Work & Impact',
  },
  {
    icon: `${process.env.PUBLIC_URL}/new_joiners.svg`,
    value: '50',
    title: 'New Joiners',
    category: 'Team achievements',
  },
  {
    icon: `${process.env.PUBLIC_URL}/awards.svg`,
    value: '105',
    title: 'Total Awards',
    category: 'Spot, A&B & Pinnacle',
  },
  {
    icon: `${process.env.PUBLIC_URL}/career_growth.svg`,
    value: '139',
    title: 'Total Promotions',
    category: 'Career growth',
  },
];

export const WORK_IMPACT_METRICS = [
  { value: '28', label: 'Engagements Completed' },
  { value: '73%', label: 'Utilization' },
];

export const COMMUNITY_EVENTS = {
  title: 'Community Events',
  // speaking_events: '-',
  cities_reached: '-',
  communities: '-',
  events: [
    // {
    //   "name": "AWS Reinvent 2025",
    //   "topic": null,
    //   "date": "Jan 18 2025",
    //   "city": "Coimbatore",
    //   "speakers": [
    //     "Nirmalmahesh Subramani",
    //     "Kumaresh Krishnapuram Ramakrishnan"
    //   ]
    // },
    // {
    //   "name": "BrowserStack",
    //   "topic": null,
    //   "date": "Jan 10 2026",
    //   "city": "Chennai",
    //   "speakers": [
    //     "Rajesh G",
    //     "Deepankumar Kumaran"
    //   ]
    // },
    {
      "name": "Grafana",
      "topic": "Modern Observability for Kubernetes: Grafana, Loki & AI Insights",
      "date": "Jan 25 2025",
      "city": "Chennai",
      "speakers": [
        "Karthick Elumalai",
        "Kamesh Raghul"
      ]
    },
    {
      "name": "Microsoft Power BI & Fabric",
      "topic": "From Data to Deployment: Power BI Pipelines Powered by Microsoft Fabric",
      "date": "Feb 22 2025",
      "city": "Chennai",
      "speakers": [
        "Dhivya S",
        "Mohamed Irfan"
      ]
    },
    {
      "name": "AWS SheTech Day",
      "topic": "From Vision to Production: Building Secure GenAI Solutions with Amazon Bedrock",
      "date": "Mar 15 2025",
      "city": "Chennai",
      "speakers": [
        "Pavithra Meganatha", "Dhivya S"
      ]
    },
    {
      "name": "Global AI Bootcamp",
      "topic": "Building the Future with AI: Agents, GenAI & Intelligent Platforms",
      "date": "Mar 29 2025",
      "city": "Coimbatore",
      "speakers": [
        "Abinash S", "Prabakaran"
      ]
    },
    {
      "name": "AWS",
      "topic": "High-Scale Architectures & AI Workflows on AWS",
      "date": "May 17 2025",
      "city": "Chennai",
      "speakers": [
        "Sai Swaroopa", "Mohamed Irfan",
      ]
    },
    {
      "name": "Snowflake",
      "topic": "Engineering Intelligent Data Platforms with Snowflake",
      "date": "Jun 21 2025",
      "city": "Chennai",
      "speakers": [
        "Vishali Sakthivel", "Vishal Periyasamy"
      ]
    },
    {
      "name": "CNCF",
      "topic": "Modern Cloud Native Delivery: From Progressive Rollouts to Secure Notebooks",
      "date": "Sep 06 2025",
      "city": "Coimbatore",
      "speakers": [
        "Kishore D", "Gokulakrishnan S"
      ]
    },
    {
      "name": "Snowflake",
      "topic": "Streaming to Insights: Next-Gen Data Pipelines on Snowflake",
      "date": "Oct 11 2025",
      "city": "Coimbatore",
      "speakers": [
        "Shanmuga Priya M", "Vikneshwara R B"
      ]
    },
    {
      "name": "Azure",
      "topic": "Enterprise AI on Azure: Platforms, Copilot Integration & OpenAI Security",
      "date": "Dec 06 2025",
      "city": "Coimbatore",
      "speakers": [
        "Subhashini", "Naveena S"
      ]
    }
  ],
};

export const MILESTONES_RECOGNITION = {
  title: 'Milestones & Recognition',
  "milestones": [
    {
      "title": "Exchange Pinnacle Award",
      "profile_image": null,
      "name": "Mohammed Ibrahim",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Yalla, Prathyusha",
      "designation": "Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "BR, Balaji",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "S, Dhivya",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Vadivel, Shanmugapriya",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Thirumurugan, Senapathi",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Saha, Prasanjeet",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Hariharan, Saishrinidhi",
      "designation": "Business Analyst",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Global Engineering Award",
      "profile_image": null,
      "name": "Subramani, Nirmalmahesh",
      "designation": "Lead Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Rajendran, Aswin Kumar",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Ng, Kevin",
      "designation": "Associate Engineer, Product Engineering",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Nick Truong",
      "designation": "Engineer, Product Engineering",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Muthuraman, Arvind",
      "designation": "Associate Director",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Pulagala, Kartheek",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Ravi Chandran, Kiran",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Shark Tank",
      "profile_image": null,
      "name": "Yashwanth Kumar, Chinthakommadinne",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "KJ, Haritha",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "R Ajay",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "P P Saravana Raja",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Sankaranarayanan, Ganapathy Subramanian",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "S Abinash",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Ganesan, Shailesh Dheep",
      "designation": "Architect, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "R Venkkataraman",
      "designation": "Senior Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Jayavel, Sapna",
      "designation": "Technical Director",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "R Aziz Rahman",
      "designation": "Lead Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Vinod, Mridula",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Venkatraman SP",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Evangelista, Manny",
      "designation": "Principal Solutions Architect, Modern Platforms",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "David Henderson",
      "designation": "Principal Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Singh Abhishek",
      "designation": "Architect, Modern Platforms DevOps",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Agentic Hackathon",
      "profile_image": null,
      "name": "Levensailor Jeff",
      "designation": "Engineering Manager, Modern Networks",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Above and Beyond",
      "profile_image": null,
      "name": "Sivaranjan Shanmugam",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Above and Beyond",
      "profile_image": null,
      "name": "Siva Nagi Reddy",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Above and Beyond",
      "profile_image": null,
      "name": "Sai Pratap Kondareddy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    }
  ],
  "spot_awards": [
    {
      "profile_image": null,
      "name": "Anush Kailash P",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Kameshwaran M",
      "designation": "Associate Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Karthikeyan S",
      "designation": "Lead Engineer, QA",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Venkat Raman",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Sricharan Kurapati",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Haritha KJ",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Subashree B",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Ramanathan Chinnasamy",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Purusothaman Kannan",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Jayaharish K",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Senapathi Thirumurugan",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Yaswanth M",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Naveen Kumar Mohanasundaram",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Harini Muralidharan",
      "designation": "Senior Engineering Manager",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Agilandeshwari G",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Ashish Kumar Verma",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Vigneshvaran N",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Preethy Rodriguez",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Mohammad Farhaan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Sep 2025"
    },
    {
      "profile_image": null,
      "name": "Preethi Angel, S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Koushik Raj, K",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Sureka, Thirunavukarasu",
      "designation": "Quality Assurance",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Lokemala, R",
      "designation": "Engineer, QA",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Shanmuga Priya M",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Ponshriharini, V",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Vignesh, J",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Keerthana Vijayarengan",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Aswathiraj K A",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Haridharan K A",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Aliasgar Kaeed Challawala",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "S, Paarkavi Priya",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Shakthivel Rajaraman",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Mathan Rajan J",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Anusha Rangesh",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Shangameshwar K",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Sakthi KP",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Subashree",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Jun 2025"
    },
    {
      "profile_image": null,
      "name": "Madhumitha R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Priyadharshini R",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Srinivasan S",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Raju Eshwaramoorthy",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Vasudeva Manikanta",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Ajay R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Gowtham S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Shakthivel Rajaraman",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Rakhul R",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Hariskumar G S",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Abirami Sri",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Jegadeeswaran TA",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Prabu S",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Mar 2025"
    },
    {
      "profile_image": null,
      "name": "Priyadharshini R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Narasimman Rajendran",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Bharath V",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Sangeetha PL",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Shivaa Vishnu S",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Jegathish A",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Goutham R",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Ajith Raj S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Sanjai R \u00a0Immanuel",
      "designation": null,
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Iniyan Meganathan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Udaya Teja Guddimetla",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Hari Vishnu Prasad",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Hariharan D",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "K S Saravanan",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Bharanidharan Boopalan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Kumaran Santhanakrishnan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Vigneswaran Balasubramanian",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Sowmiya Aruldoss",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Mooli Pranay Teja Reddy",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Ayushi Saxena",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "K, Arulmozhikumar",
      "designation": "Associate Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Srinivasan S",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "ArunKumar S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Utpal Tripathi",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Urvashi Surjey",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    },
    {
      "profile_image": null,
      "name": "Dharsini Revathy",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ],
      "date": "Dec 2025"
    }
  ],
  "promotions": [
    {
      "profile_image": null,
      "name": "Sivaranjan Shanmugam",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sathasivam Rangasamy",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Harini Muralidharan",
      "designation": "Senior Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Venkata Subhash Burramsetty",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Yuvaraj Rajendran",
      "designation": "Senior Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Jayasuriyan Jayaraj",
      "designation": "Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Shailesh Dheep Ganesan",
      "designation": "Architect, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kokila Elangovan",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Naveenkumar Shankar",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Nirmal Mahesh Subramani",
      "designation": "Lead Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vanmathi Moorthy",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Karthick Elumalai",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ragavan Pitchai",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vignesh Angamuthu",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Prathyusha Yalla",
      "designation": "Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Chockalinga Prasanna",
      "designation": "Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Saravanan Ks",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Abhilash Ramachandran",
      "designation": "Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Shruthi Gautham",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Fareed Ahamed",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Nirmal Abaranam",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Siddhu Nallasivam",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Jenef Jeshurun",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Balaji J",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kishan Lal",
      "designation": "Lead Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aziz Rahman",
      "designation": "Lead Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Shoban MU",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Tejaswini Nagarajan",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arshina Dange",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Siva Bhargava Adi",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Tammali Deepak",
      "designation": "Senior Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ajith C Ravi",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vaidhyalingam T",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sanjay Balasubramanian",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aarthi Govardhanan",
      "designation": "Associate Director",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ajantha Selvamani",
      "designation": "Senior Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Saranya Loganathan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aravinda Krishnan H",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arunkumar Mohandas",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ajay R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Keerthivasan Moorthy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vaishnavi Suraj Kumar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Magesh Kumar Nallasivam",
      "designation": "Senior Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Pranesh Palanisamy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Abinash Sankaran",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Saravana Raja Pachapatti Palanisamy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Yashwanth K",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Priyadharsini Muthusamy Venkatesan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Prem S R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Dhivya S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Pavithra Meganathan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vigneshwar M",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Lokeshvar S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Giridhara Prasath Govindarajan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Subashree Balakrishnan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Samraj Anandun Baskaran",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Lakshmi MR",
      "designation": "Senior Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Shridevi Kandasami",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Keerthi Malini Stanly Jayakumar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Hari Prasath Varadharajan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Shakthivel Rajaraman",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ganapathy Subramanian Sankaranarayanan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Devamuthan Sankar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Saairaam Prasad K V",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kumaran Santhanakrishnan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Mohamed Rella Mohamed Raffick",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sai Purushoth Ganesan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sai Pratap Kondreddy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vibin Gowtham Anandh",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Barathkumar Murugesh",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Avinash Balajee Ramasamy Muthusamy",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Iniyan Meganathan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sricharan Kurapati",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Manya Balagurunathan Naresh",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aliasgar Kaeed Challawala",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Subbu Prasant Ponmuthazhakan",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Anush Kailash P",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ashwin Balasubramaniam",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Eswara Prasad Sridharan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kailash Sridhar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Bharath Madhu",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Haridharan Krishnamoorthy Angulakshmi",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Preethi Ravi Kumar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Dhanush R",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Bharat Varshan Soppallu Manoharan",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kumaresh Krishnapuram Ramakrishnan",
      "designation": "Senior Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Stanley Prabakar",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sankareswari Athiappan",
      "designation": "Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Chakali Gangadhar",
      "designation": "Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Krithika N",
      "designation": "Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arun Anbazhagan",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Godlin Josheela Rani Somadhas",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Zeenathul Farina A",
      "designation": "Associate Director",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Raja Ishthiyak",
      "designation": "Engineering Manager",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Vinoth Kumar Ganesan",
      "designation": "Director, Digital Operations",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Srinivasan S",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Manjula E",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arunkumar S",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Balakumar KS",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Rishi Kumar GG",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Naveen Kumar K",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "David Raj E",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Mohan D",
      "designation": "Senior Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Yogesh Sathasivam",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Visnu Ravichandran",
      "designation": "Lead Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arvinth K P",
      "designation": "Senior Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ashok Raja S",
      "designation": "Associate Architect",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Manoj Manickam",
      "designation": "Associate Solution Owner",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Senadhian Gnanasekar",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Senthamil Chezhian E",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "SAKTHI SASI VELAR K P",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "SUBHASHINI S V",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Bharath V",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "SHANGAMESHWAR KANDAVADIVEL",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kavin Kumar M",
      "designation": "Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "VENKATRAMAN S P",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Kousik Raj Kabilan",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aswathi Sivadasan",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ponshriharini Venkatesh",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sanjai Ragul Murugesh",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Jaivignesh V",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Mridula Vinod",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Huzair Ahmed",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Venkata Sujan Dasari",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Anup Kumar Mridha",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Arvind Mali",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Aman Agrawal",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Utpal Tripathi",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Akshaya Balakrishnan",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Ayushi Saxena",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "JAYESH V A",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Akshay Telang",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Akash Kumar S",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sridhar S K",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "R P Ankitha",
      "designation": "Business Analyst",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Darsh Dave",
      "designation": "Business Analyst",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Manoj Jeyaraj",
      "designation": "Engineer",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Chidambaranathan S",
      "designation": "Associate Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "profile_image": null,
      "name": "Sachin M Sabariram",
      "designation": "Associate Engineer, Innovation",
      "tags": [
        "Build&Engineering"

      ]
    }
  ],
  "certifications": [
    {
      "vendor": "AWS",
      "count": 46
    },
    {
      "vendor": "Azure",
      "count": 27
    },
    {
      "vendor": "GCP",
      "count": 4
    },
    {
      "vendor": "DataFabric",
      "count": 5
    },
    {
      "vendor": "SnowFlake",
      "count": 5
    },
    {
      "vendor": "Project Management",
      "count": 2
    },
    {
      "vendor": "UI / UX",
      "count": 1
    },
    {
      "vendor": "Devops",
      "count": 9
    },
    {
      "vendor": "Security",
      "count": 1
    },
    {
      "vendor": "ServiceNow",
      "count": 6
    },
    {
      "vendor": "Splunk",
      "count": 2
    }
  ]
};

export const PROJECTS_INFO = [
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/ushg.jpg`,
    "title": "USHG - Union Square Hospitality Group",
    "challenge": "Following a broad ideation exercise, there was a need to identify business-relevant use cases that could deliver real value and transition from concept to execution. The key challenge was prioritizing ideas that aligned with strategic goals while also being feasible for near-term delivery.",
    "solution": "An ideation workshop was conducted that generated 23 business-focused use cases. These ideas were assessed based on impact, feasibility, and alignment with organizational priorities, leading to a recommendation to pursue an AI-focused Learning Journeys feature as the most compelling opportunity.",
    "outcomes": [
      "23 business-focused use cases identified for strategic consideration",
      "AI-focused Learning Journeys feature prioritized as a high-impact initiative",
      "New delivery engagement initiated and currently in progress",
      "Clear progression from ideation to execution, reinforcing stakeholder confidence"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/pga.png`,
    "title": "PGA - Professional Golfers Association",
    "challenge": "The existing Replay Application contained significant workflow and functional gaps that hindered usability and operational efficiency. Limited visibility into end-to-end user journeys made it difficult for stakeholders to clearly identify where processes were breaking down and why the application was no longer meeting business needs.",
    "solution": "An ideation workshop was conducted that included detailed journey mapping across key user workflows. This exercise enabled a thorough analysis of the current-state experience, uncovering inefficiencies, missing capabilities, and misaligned functionality within the Replay Application.",
    "outcomes": [
      "Identified critical workflow and functionality shortfalls in the current Replay Application",
      "Established clear, journey-mapped insights into user pain points and improvement areas",
      "Aligned stakeholders on the need for a redesigned solution",
      "Triggered discussions for a second engagement to build a new Replay Application addressing the identified gaps"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/autodesk.png`,
    "title": "Autodesk - Global AI, RAG & Personalization Platform",
    "challenge": "Scaling conversational AI, ML personalization, analytics instrumentation, and real-time behavioral intelligence across global web properties while standardizing ML infrastructure.",
    "solution": "Built a unified RAG framework orchestrated with LangGraph, migrated ML models to Autodesk\u2019s AMP platform on AWS SageMaker, implemented Kafka-Flink real-time data pipelines for personalization, and completed migration of analytics instrumentation to the internal CJS platform.",
    "outcomes": [
      "Launched first ML-powered personalization",
      "Enabled real-time behavioral tracking & ranking personalization",
      "Standardized ML on AMP platform",
      "Consolidated RAG into a scalable unified framework",
      "Modernized analytics instrumentation",
      "Expanded global personalization readiness"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/welness_way.png`,
    "title": "The Wellness Way – Strategic Delivery & Partnership Growth",
    "challenge": "Stabilizing delivery quality, overcoming CSAT concerns, and building long-term trust while supporting ongoing platform initiatives.",
    "solution": "Dedicated cross-functional team ownership, strong collaboration with customer leadership, consistent delivery, and proactive issue resolution while acting as a strategic partner rather than a vendor.",
    "outcomes": [
      "Engagement extended through July 2026",
      "Recognized by executive leadership as a strategic partner",
      "CSAT concerns transformed into long-term trust",
      "Team members received individual recognition for ownership and reliability"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/tdk_sensei.png`,
    "title": "TDK SensEI – IoT Platform & ML Dashboard",
    "challenge": "Building a scalable IoT data platform with integrated ML pipelines and operational dashboards.",
    "solution": "Agile development of web dashboard across 8 sprints, integrating sensors, gateways, assets, and ML pipelines.",
    "outcomes": [
      "Critical dashboard features delivered",
      "Strong customer confidence in delivery model",
      "Expansion discussions for mobile app & Phase 2"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/swapa-white.png`,
    "title": "SWAPA – Platform Modernization & Dynamics Transformation",
    "challenge": "Complex legacy .NET framework, CMS incompatibilities, headless architecture demands, and domain-heavy case management.",
    "solution": "Migration to .NET Core, custom CMS integration solutions, Dynamics 365 implementation with AI knowledge base, automation, and Power Platform foundation.",
    "outcomes": [
      "Successful .NET Framework → .NET Core migration",
      "AI-powered knowledge article suggestions",
      "Automated case categorization & lifecycle workflows",
      "Stable rollout backed by rigorous testing"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/carollo.png`,
    "title": "Carollo – Enterprise Application Stability & Rollout",
    "challenge": "High-risk production releases and large-scale user migration from legacy systems.",
    "solution": "End-to-end ownership of Compensation App enhancements, aggressive regression testing, CDP rollover planning, and real-time support.",
    "outcomes": [
      "Compensation app production release with <10 post-release bugs",
      "CDP system rolled out to ~1,000 users",
      "Legacy platform fully replaced",
      "Strong customer trust during production approvals"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/health_sense_ai.jpg`,
    "title": "HealthSense AI – Clinical GenAI Platform",
    "challenge": "Transforming provider-patient conversations into structured clinical notes within a complex healthcare environment.",
    "solution": "AWS-funded AI initiative with cross-functional delivery across design, ML, DevOps, and QA.",
    "outcomes": [
      "Phase 1 successfully completed",
      "CIO-level recognition",
      "Production-ready foundation for future phases",
      "High-quality, stable GenAI healthcare solution"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/tokyo_marine.svg`,
    "title": "Tokio Marine – Azure Governance & Automation",
    "challenge": "Ensuring Azure compliance, service governance, and discovery visibility across complex environments.",
    "solution": "Azure policy automation, custom Wiz discovery solutions, AKS and Outpost enablement.",
    "outcomes": [
      "Automated onboarding for Azure services",
      "Improved Key Vault & ACR visibility",
      "Secure, scalable AKS and Outpost deployments"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/bdo.png`,
    "title": "BDO - Data Platform Acceleration",
    "challenge": "Performance bottlenecks, timeout failures with large datasets, and heavy production support needs.",
    "solution": "Optimized ETLs, multithreaded Azure Functions, durable workflows, and scalable architecture design.",
    "outcomes": [
      "Achieved ~60% faster ETL performance",
      "55% reduction in production support",
      "Zero critical post-launch bugs",
      "Scalable architecture for future growth"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/ardent_mills.png`,
    "title": "Ardent Mills - AI-Assisted Engineering Acceleration",
    "challenge": "Compressed feature timelines and slow test automation cycles.",
    "solution": "Adoption of Co-Pilot with custom MCPs, Playwright automation, framework modernization, and AI-assisted test migration.",
    "outcomes": [
      "~44% faster feature delivery",
      "Test automation up to 5x faster",
      "650 → 1,300+ modernized test cases",
      "Major regression confidence improvement"
    ]
  },

  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": `${process.env.PUBLIC_URL}/project-logos/samatarian.png`,
    "title": "Samaritan Ministries – Document Visibility Feature",
    "challenge": "Uploaded documents lacked preview capability, creating operational inefficiencies for staff.",
    "solution": "Implemented a 'Show Uploaded Document' feature within the Needs application",
    "outcomes": [
      "Improved staff confidence and workflow",
      "Resolved a 7-year pending request",
      "Enhanced user experience"
    ]
  },
  {
    "tags": [
      "Build&Engineering"

    ],
    "logo_url": null,
    "title": "UPSIS – Modernization & Data Platform Enablement",
    "challenge": "Legacy application landscape and need for modernization clarity plus modern analytics enablement.",
    "solution": "Application modernization assessment with roadmap + Fabric Rapid Start POC including pipeline setup and reporting.",
    "outcomes": [
      "Modernization discovery & roadmap delivered",
      "Positive customer response",
      "Contract finalization in progress",
      "Fabric POC completed with working data pipeline and reports"
    ]
  },

]

export const WORKSHOPS_CONDUCTED = {
  title: 'Workshops Conducted',
  workshops: [
    {
      "name": "NHL Multi-source Video",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/nhl.png`,
    },
    {
      "name": "USHG",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/ushg.jpg`,
    },
    {
      "name": "MLS",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/mls.svg`,
    },
    {
      "name": "Proskauer",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/proskaurer.png`,
    },
    {
      "name": "AGL Credit",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/agl.jpg`,
    },
    {
      "name": "Par Pacific",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/par_pacific.png`,
    },
    {
      "name": "Baylor College of Medicine",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/bcm.png`,
    },
    {
      "name": "Moffitt Cancer Center",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/moffitt.jpeg`,
    },
    {
      "name": "Neighborly",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/nbly.jpeg`,
    },
    {
      "name": "Accordion",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/accordian.jpg`,
    },
    {
      "name": "PGA Tour",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/pga.png`,
    },
    {
      "name": "Veritext",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/veritext.png`,
    },
    {
      "name": "InfoGrate",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/infrograte.jpeg`,
    },
    {
      "name": "Rain for Rent",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/rain.png`,
    },
    {
      "name": "LevelPlay",
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/level.png`,
    },
  ]
};

export const ACTIVE_INITIATIVES = {
  title: 'Active Initiatives',
  initiatives: [
    {
      "title": ".NET Self-Enablement",
      "description": "Empowering individuals to independently learn, build, and deliver solutions using .NET with confidence and best practices.",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "GenAI Enablement",
      "description": "AI enablement programme targetting for all people.",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "PowerBI Enablement",
      "description": "Completed pilot batch training for 8 people",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "GCP Enablement",
      "description": "Self-enablement on the GCP Cloud Stack",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "Academic Training Batch",
      "description": "Initiative to train 30+  students on multiple technology stacks including AWS, Azure",
      "tags": [
        "Build&Engineering"

      ]
    },
    {
      "title": "HAI Build",
      "description": "HAI Build is Presidio's human-centric approach to harnessing Generative AI across the software development lifecycle.",
      "tags": [
        "Build&Engineering"

      ]
    }
  ]
};

export const INNOVATION = {
  title: 'Innovation',
  pocs: '4',
  unique_technologies: '22',
  innovations: [
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/intra.jpg`,
      "title": "Intrado CST – AI-Powered Legacy System Recovery",
      "description": "AI-assisted modernization approach used to reverse engineer a legacy application with no source code. Business logic, workflows, and documentation were reconstructed to enable secure Azure migration and a fully rebuilt, future-ready platform."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/auto_desk.png`,
      "title": "Autodesk – Unified RAG Orchestration Framework",
      "description": "A scalable RAG architecture implemented for Autodesk that consolidates multiple AI knowledge models into a single orchestrated flow. It standardizes enterprise AI delivery and enables consistent, governed conversational experiences across platforms."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/auto_desk.png`,
      "title": "Autodesk NextDotCom – Real-Time ML Personalization Engine",
      "description": "A streaming data and machine learning framework built for Autodesk that processes behavioral signals in near real time. Powers adaptive digital experiences using modern instrumentation, Kafka-Flink pipelines, and scalable ML platforms."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/health_sense_ai.jpg`,
      "title": "HealthSense AI – GenAI Clinical Documentation Platform",
      "description": "Healthcare AI solution that transforms provider–patient conversations into structured clinical notes. Built as part of the HealthSense AI initiative, it combines generative AI, secure cloud architecture, and production-grade DevOps to improve clinical workflows."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/sirius_logo.png`,
      "title": "SiriusXM – AI-Assisted Data Migration Factory",
      "description": "A modernization factory model used in the SiriusXM Talend-to-AWS program that leverages AI-driven automation to accelerate large-scale ETL migrations. It standardizes transformation patterns and enables zero-disruption transitions from legacy data platforms."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/ardent_mills.png`,
      "title": "Ardent Mills – Copilot-Driven Engineering Acceleration Model",
      "description": "An AI-augmented development approach that combines GitHub Copilot, custom MCPs, and automation frameworks to accelerate feature delivery, modernize test suites, and significantly improve engineering productivity and release velocity."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/spc.jpg`,
      "title": "SPC",
      "description": "RAG-based Q&A chatbot using 12+ years of research notes."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/ecu_health.png`,
      "title": "ECU Health",
      "description": "GenAI-powered chatbot for clinicians to access practice guidelines."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/sarepta.png`,
      "title": "Sarepta",
      "description": "RAG chatbot for health data and disease insights"
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/planhub.png`,
      "title": "PlanHub AI",
      "description": "AI for streamlined bidding solutions."
    },
    {
      "logo_url": `${process.env.PUBLIC_URL}/project-logos/apc.jpg`,
      "title": "APC",
      "description": "Application AI Assistant for user experience improvement."
    },

  ],
};

export const LIFE_BEYOND_WORK = {
  title: 'Life Beyond the Work',
  events: [
    {
      title: 'Diwali 2025',
      image_url: 'events/diwali.jpeg',
    },
    {
      title: 'Christmas 2025',
      image_url: 'events/christmas.jpeg',
    },
    {
      title: 'Independance Day 2025',
      image_url: 'events/independance_day.jpeg',
    },
    {
      title: 'Little Fiesta 2025',
      image_url: 'events/little_fiesta.JPG',
    },
    {
      title: 'Mens Day 2025',
      image_url: 'events/mens_day.JPG',
    },
    {
      title: 'Pink Out Day 2025',
      image_url: 'events/pink_out_day.jpeg',
    },
    {
      title: 'Pongal 2025',
      image_url: 'events/pongal.png',
    },
    {
      title: 'Thanks Giving 2025',
      image_url: 'events/thanks_giving.jpeg',
    },
    {
      title: 'Womens Day 2025',
      image_url: 'events/womens_day.JPG',
    },
  ],
};

export const CUSTOMER_LEADERSHIP_VISITS = {
  title: 'Customer & Leadership Visits',
  visits: [
    {
      "title": "Coffee with Leadership",
      "image_urls": [
        'events/cofee_with_leadership.JPG'
      ],
      "location": "Chennai"
    }
  ],
};

export const PEOPLE_BEHIND_IMPACT = {
  title: 'The People Behind the Impact',
  people: [
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/andres.jpeg`,
      name: 'de Corral, Andres',
      designation: 'Vice President',
      tags: ['US'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/ragu.jpg`,
      name: 'Adinarayanan, Ragu',
      designation: 'Sr. Engineering VP',
      tags: ['US'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/manny.png`,
      name: 'Rodriguez-Perez, Manny',
      designation: 'Engineering VP, Cloud GTM',
      tags: ['US'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/senthil.jpg`,
      name: 'Murugan, Senthil',
      designation: 'Engineering AVP',
      tags: ['India'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/phil.jpeg`,
      name: 'Filippelli, Philip',
      designation: 'Director, Strategy and Innovation',
      tags: ['US'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/bryan.jpeg`,
      name: 'Allison, Bryan',
      designation: 'Director, Practice Development',
      tags: ['US'],
    },
    {
      profile_image: `${process.env.PUBLIC_URL}/leadership/tom.jpeg`,
      name: 'Cahill, Tom',
      designation: 'Digital Strategy Director',
      tags: ['US'],
    },
  ],
};

export const FUTURE_FOCUS = {
    title: 'Future Focus',
    focus_events:[
    {
      title: 'Tech Radar',
      keypoints:['Generative AI & LLMOps', 'Serverless & Event-driven architecture', 'Platform engineering', 'AI-led solution design', 'DecSecOps & automation']
    },
    {
      title: 'Competency',
      keypoints:['AWS advanced certifications', 'AI/ML specialization', 'Security & compliance expertise', 'Domain-driven design']
      },
    {
      title: 'Offerings',
      keypoints:['AI-powered document processing', 'Cloud modernization programs', 'Developer experience transformation', 'Intelligent automation solutions']
    }
  ]
}
